"use strict";

var _toConsumableArray = require("C:\\Users\\Administrator\\Desktop\\KaporgLatestC\\KAPorg-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/toConsumableArray");
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSocketIoContext = void 0;
var hermes_channel_1 = __importDefault(require("hermes-channel"));
var utils_1 = require("../utils");
var hooks_1 = require("./hooks");
var provider_1 = require("./provider");
var providerNativeFactory_1 = require("./provider/providerNativeFactory");
var SOCEKT_IO_SEND = "SOCEKT_IO_SEND";
function createSocketIoContext(options) {
  var events = [];
  var context = {
    connection: null,
    useSocketEffect: null,
    shareConnectionBetweenTab: (options === null || options === void 0 ? void 0 : options.shareConnectionBetweenTab) || false,
    invoke: function invoke(methodName) {
      var _a;
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      if (!context.shareConnectionBetweenTab) {
        var _a2;
        (_a = context.connection) === null || _a === void 0 ? void 0 : (_a2 = _a).emit.apply(_a2, [methodName].concat(args));
        return;
      }
      (0, utils_1.sendWithHermes)(SOCEKT_IO_SEND, {
        methodName: methodName,
        args: args
      }, context.shareConnectionBetweenTab);
    },
    Provider: null,
    on: function on(event) {
      var _a;
      if (!events.includes(event)) {
        (_a = context.connection) === null || _a === void 0 ? void 0 : _a.on(event, function (message) {
          (0, utils_1.sendWithHermes)(event, message, context.shareConnectionBetweenTab);
        });
      }
      events.push(event);
    },
    off: function off(event) {
      var _a;
      if (events.includes(event)) {
        events.splice(events.indexOf(event), 1);
      }
      if (!events.includes(event)) {
        (_a = context.connection) === null || _a === void 0 ? void 0 : _a.off(event);
      }
    },
    //@ts-ignore
    reOn: function reOn() {
      var uniqueEvents = (0, utils_1.removeDuplicates)(events);
      uniqueEvents.forEach(function (event) {
        var _a;
        (_a = context.connection) === null || _a === void 0 ? void 0 : _a.on(event, function (message) {
          (0, utils_1.sendWithHermes)(event, message, context.shareConnectionBetweenTab);
        });
      });
    }
  };
  context.Provider = context.shareConnectionBetweenTab ? (0, provider_1.providerFactory)(context) : (0, providerNativeFactory_1.providerNativeFactory)(context);
  context;
  context.useSocketEffect = (0, hooks_1.createUseSocketEffect)(context);
  hermes_channel_1.default.on(SOCEKT_IO_SEND, function (data) {
    var _a;
    if ((_a = context.connection) === null || _a === void 0 ? void 0 : _a.connected) {
      var _context$connection;
      (_context$connection = context.connection).emit.apply(_context$connection, [data.methodName].concat(_toConsumableArray(data.args)));
    }
  });
  return context;
}
exports.createSocketIoContext = createSocketIoContext;